import CompanyLayout from '@/components/feature/CompanyLayout';
import { useTheme } from '@/contexts/ThemeContext';
import { useTranslation } from 'react-i18next';

const companyNavItems = [
  { path: '/about', label: 'About ZhiSu' },
  { path: '/careers', label: 'Careers' },
  { path: '/contact', label: 'Contact' },
  { path: '/press', label: 'Press & Media' },
  { path: '/brand', label: 'Brand Guidelines' },
];

const pressReleases = [
  {
    date: 'June 15, 2026',
    title: 'ZhiSu Surpasses $2.8 Billion in Cumulative Trading Volume',
    summary: 'The AI-native perpetuals exchange reaches a major milestone just 18 months after mainnet launch, with over 145,000 active traders across 120 countries.',
    source: 'ZhiSu Blog',
  },
  {
    date: 'May 28, 2026',
    title: 'ZhiSu Launches AI Trading Agents v2 with Multi-Chain Support',
    summary: 'The latest version introduces 12 new AI-powered trading strategies, cross-chain liquidity aggregation, and institutional-grade API access.',
    source: 'CoinDesk',
  },
  {
    date: 'April 10, 2026',
    title: 'ZhiSu Raises $45M Series B Led by Polychain Capital',
    summary: 'The funding round brings total capital raised to $78M and will accelerate expansion into prediction markets and mobile trading infrastructure.',
    source: 'The Block',
  },
  {
    date: 'March 3, 2026',
    title: 'ZhiSu Becomes First Perpetuals DEX to Integrate HyperEVM Multi-Chain Bridge',
    summary: 'Users can now trade perpetual futures with unified liquidity across Ethereum, Solana, Arbitrum, and Base without leaving the platform.',
    source: 'Decrypt',
  },
  {
    date: 'February 14, 2026',
    title: 'ZhiSu Achieves Sub-50ms Average Execution Latency',
    summary: 'Engineering breakthrough reduces order execution time by 40%, setting a new standard for decentralized derivatives trading performance.',
    source: 'ZhiSu Blog',
  },
];

export default function PressPage() {
  const { isDark } = useTheme();
  const { t } = useTranslation();
  const bgCard = isDark ? 'bg-[#0a0a0a]' : 'bg-white';
  const borderLight = isDark ? 'border-white/[0.06]' : 'border-black/[0.06]';
  const textPrimary = isDark ? 'text-white' : 'text-[#111]';
  const textSecondary = isDark ? 'text-[#888]' : 'text-[#666]';
  const textMuted = isDark ? 'text-[#555]' : 'text-[#999]';

  return (
    <CompanyLayout
      title={t('press.title', 'Press & Media')}
      subtitle={t('press.subtitle', 'Latest news, announcements, and media coverage about ZhiSu')}
      category="Company"
      navItems={companyNavItems}
    >
      <div className="space-y-4">
        {pressReleases.map((item, i) => (
          <div key={i} className={`p-5 rounded-xl border ${borderLight} ${bgCard}`}>
            <div className={`text-xs uppercase tracking-wider mb-2 ${textMuted}`}>{item.date} &middot; {item.source}</div>
            <h3 className={`font-semibold mb-2 ${textPrimary}`}>{item.title}</h3>
            <p className={`text-sm leading-relaxed ${textSecondary}`}>{item.summary}</p>
          </div>
        ))}
      </div>

      <div className={`mt-8 p-5 rounded-xl border ${borderLight} ${bgCard}`}>
        <h3 className={`font-semibold mb-2 ${textPrimary}`}>{t('press.mediaContact', 'Media Inquiries')}</h3>
        <p className={`text-sm mb-3 ${textSecondary}`}>
          For press kits, interview requests, and media partnerships, please contact our communications team.
        </p>
        <a href="mailto:press@zhisu.trade" className="text-sm text-[#00ff88] hover:underline">
          {t('press.pressEmail', 'press@zhisu.trade')}
        </a>
      </div>
    </CompanyLayout>
  );
}